// extracted by mini-css-extract-plugin
module.exports = {"MobileControls":"_2ptB7","MobileControls__Block":"nhwM3","MobileControls__ModalContent":"XxMcj"};